'use client';

import { jsxs, jsx } from "react/jsx-runtime";
import a__default, { useLayoutEffect } from "react";
import { Text } from "../../atoms/Text/Text.js";
import { useLiveAnnouncement } from "../../utils/hooks/useLiveAnnouncement.js";
import { wrapIfTextCompatible } from "../../utils/props/wrapIfTextCompatible.js";
import { textWrapper } from "./InlineNotification.css.js";
function Contents({
  liveId,
  ...props
}) {
  const { title, description, label, a11yMessage, a11yImportance } = props;
  const descriptionRef = a__default.useRef(null);
  const announce = useLiveAnnouncement();
  useLayoutEffect(() => {
    var _a;
    if (a11yImportance === "none") return;
    const descriptionText = ((_a = descriptionRef.current) == null ? void 0 : _a.innerText) ?? "";
    const contents = a11yMessage || `${title}. ${descriptionText}`;
    announce(`${label}. ${contents}`, { id: liveId, a11yImportance });
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: textWrapper, children: [
    a11yMessage && /* @__PURE__ */ jsx(Text, { visuallyHidden: true, children: a11yMessage }),
    /* @__PURE__ */ jsx(
      Text,
      {
        "aria-hidden": a11yMessage ? "true" : void 0,
        color: "onLight.text.primary",
        variant: "label.md",
        children: title
      }
    ),
    description && wrapIfTextCompatible(description, (c) => /* @__PURE__ */ jsx(
      Text,
      {
        "aria-hidden": a11yMessage ? "true" : void 0,
        color: "onLight.text.primary",
        ref: descriptionRef,
        variant: "body.base",
        children: c
      }
    ))
  ] });
}
export {
  Contents
};
